import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const useFetchVaPayments = (page, pageSize, startDate, endDate, gtPrev, name, legacy, manual) => {
  return useQuery(
    ['va-payments', { page, pageSize, startDate, endDate, gtPrev, name, legacy, manual }],
    async () => {
      const res = await axios.get('/va-payments', {
        params: { page, pageSize, startDate, endDate, gtPrev, name, legacy, manual },
      });
      return res.data;
    },
    { keepPreviousData: true },
  );
};


